import Dashboard from "../admin/Dashboard";
import PatientDashboard from "../patient/PatientDashboard";
import TherapistDashboard from "../therapist/TherapistDashboard";
import NoAccessScreen from "./NoAccessScreen";
import { usePortal } from "../../authContext/portalContext";

// Mounted at the single /dashboard route for every authenticated user.
// Content is picked by the currently active portal, not the URL — an
// account with multiple roles switches portals in-app via the sidebar.
function DashboardRouter() {
  const { activePortal } = usePortal();

  if (activePortal === "admin") return <Dashboard />;
  if (activePortal === "therapist") return <TherapistDashboard />;
  if (activePortal === "patient") return <PatientDashboard />;
  return <NoAccessScreen />;
}

export default DashboardRouter;
